"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const bind_decorator_1 = __importDefault(require("bind-decorator"));
const classnames_1 = __importDefault(require("classnames"));
const debounce_1 = require("debounce");
const mobx_1 = require("mobx");
const mobx_react_1 = require("mobx-react");
const react_1 = __importDefault(require("react"));
const react_data_table_component_1 = __importDefault(require("react-data-table-component"));
const Icon_1 = __importDefault(require("../../common/js/atoms/Icon"));
const Zupicons_1 = __importDefault(require("../../common/js/enums/Zupicons"));
const _variables_scss_1 = __importDefault(require("../../scss/_variables.scss"));
const DataTableTheme_1 = __importDefault(require("../enums/DataTableTheme"));
const SortingPropertyModel_1 = require("../models/SortingPropertyModel");
const dataTableStyles = {
    headRow: {
        style: {
            minHeight: '1.625rem',
        },
    },
    headCells: {
        style: {
            color: _variables_scss_1.default.gray_400,
            fontSize: '0.875rem',
            lineHeight: '1.25rem',
            fontWeight: 'normal',
            minHeight: '2.875rem',
            overflow: 'visible',
        },
    },
    rows: {
        style: {
            borderTopWidth: '1px',
            borderTopColor: _variables_scss_1.default.gray_200,
            borderTopStyle: 'solid',
        },
    },
    cells: {
        style: {
            fontSize: _variables_scss_1.default.font_size_base,
            lineHeight: '1.5rem',
            minHeight: '2.875rem',
        },
    },
    expanderCell: {
        style: {
            flex: '0 0 3.125rem',
        },
    },
};
class TableTile extends react_1.default.Component {
    debouncedUpdateLocalStorage = (0, debounce_1.debounce)(this.updateLocalStorageSortingValue, 500);
    tableRef = react_1.default.createRef();
    tableHeaderRef = react_1.default.createRef();
    constructor(props) {
        super(props);
        (0, mobx_1.makeObservable)(this, {
            defaultSortField: mobx_1.computed,
            defaultSortAsc: mobx_1.computed,
        });
    }
    componentDidMount() {
        document.addEventListener('scroll', this.onScrollInput);
    }
    componentWillUnmount() {
        document.removeEventListener('scroll', this.onScrollInput);
    }
    get defaultSortField() {
        return this.getLocalStorageSortingValue()?.selector ?? this.props.defaultSortField;
    }
    get defaultSortAsc() {
        const sortDirection = this.getLocalStorageSortingValue()?.sortDirection;
        return sortDirection !== SortingPropertyModel_1.SortingDirection.desc;
    }
    render() {
        const AdditionalHeaderButtonComponent = this.props.additionalHeaderButtonComponent;
        return (react_1.default.createElement("div", { className: (0, classnames_1.default)('znd-table-tile', { 'znd-table-tile--inner-scroll': this.props.scrollInside }) },
            react_1.default.createElement("div", { className: "d-flex align-items-start znd-table-tile__header", ref: this.tableHeaderRef },
                this.props.title ? (react_1.default.createElement("div", { className: "znd-table-tile__header-title t-card-title" }, this.props.title)) : null,
                AdditionalHeaderButtonComponent ? (react_1.default.createElement("div", { className: "ml-auto" },
                    react_1.default.createElement(AdditionalHeaderButtonComponent, null))) : null),
            this.props.header ?? null,
            react_1.default.createElement("div", { className: "znd-table-tile__scroll-wrapper", ref: this.tableRef },
                react_1.default.createElement(react_data_table_component_1.default, { className: 'znd-table-tile__table', columns: this.props.columns, data: this.props.data, theme: DataTableTheme_1.default.main, noHeader: true, customStyles: dataTableStyles, expandOnRowClicked: true, expandableRows: !!this.props.expandableComponent, expandableRowsComponent: this.props.expandableComponent, expandableIcon: this.getExpandableIcon(), expandableRowExpanded: this.props.onExpandedRow, responsive: false, onSort: this.debouncedUpdateLocalStorage, defaultSortAsc: this.defaultSortAsc, defaultSortFieldId: this.defaultSortField, sortIcon: react_1.default.createElement(Icon_1.default, { name: Zupicons_1.default.caretDown, className: 'znd-table-tile__icon-caret ml-2' }), noDataComponent: this.props.noDataText }))));
    }
    onScrollInput() {
        const tableHead = this.tableRef.current?.querySelector('.rdt_TableHead');
        const tableHeadRect = this.tableRef.current?.getBoundingClientRect();
        const tileHeadRect = this.tableHeaderRef.current?.getBoundingClientRect();
        if (!tileHeadRect || !tableHeadRect || !tableHead) {
            return;
        }
        // Moves the header element up by 0.5 pixels to avoid having a small, but noticeable, gap between it and the sticky element above it.
        const distanceOffset = -0.5;
        const tableHeaderStickyTop = Math.floor(tileHeadRect?.top + tileHeadRect?.height - tableHeadRect?.top);
        const backgroundColor = '#fff';
        const zIndex = '1000';
        const borderBottom = '1px solid #d1dae1';
        if (tableHeaderStickyTop > 0) {
            tableHead.style.transform = 'translateY(' + (tableHeaderStickyTop + distanceOffset) + 'px)';
            tableHead.style.backgroundColor = backgroundColor;
            tableHead.style.zIndex = zIndex;
            tableHead.style.borderBottom = borderBottom;
        }
        else {
            tableHead.style.transform = '';
            tableHead.style.backgroundColor = '';
            tableHead.style.zIndex = '';
            tableHead.style.borderBottom = '';
        }
    }
    updateLocalStorageSortingValue(column, sortDirection) {
        const localStorageSortingValue = {
            selector: String(column.selector),
            sortDirection: sortDirection,
        };
        localStorage.setItem(this.props.localStorageKey, JSON.stringify(localStorageSortingValue));
    }
    getLocalStorageSortingValue() {
        const localStorageSortingValue = localStorage.getItem(this.props.localStorageKey);
        if (!localStorageSortingValue) {
            return null;
        }
        return JSON.parse(localStorageSortingValue);
    }
    getExpandableIcon() {
        if (this.props.expandableComponent === null) {
            return { expanded: '', collapsed: '' };
        }
        return {
            expanded: react_1.default.createElement(Icon_1.default, { name: Zupicons_1.default.caretDown, className: 'znd-table-tile__icon-caret' }),
            collapsed: react_1.default.createElement(Icon_1.default, { name: Zupicons_1.default.caretRight, className: 'znd-table-tile__icon-caret' }),
        };
    }
}
__decorate([
    bind_decorator_1.default
], TableTile.prototype, "onScrollInput", null);
__decorate([
    bind_decorator_1.default
], TableTile.prototype, "updateLocalStorageSortingValue", null);
__decorate([
    bind_decorator_1.default
], TableTile.prototype, "getLocalStorageSortingValue", null);
__decorate([
    bind_decorator_1.default
], TableTile.prototype, "getExpandableIcon", null);
exports.default = (0, mobx_react_1.observer)(TableTile);
